import { useState, useEffect, useCallback } from 'react';
import {
  formatAvailabilityLabel,
  getAvailabilityQuarter,
  getMsUntilNextQuarterStart,
} from '../utils/getAvailabilityQuarter';

/**
 * Footer availability — current Q/year, auto-updates at each quarter boundary
 * (1 Jan, 1 Apr, 1 Jul, 1 Oct) and when the tab becomes visible again after sleep.
 */
export default function useAvailabilityLabel() {
  const read = useCallback(() => {
    const { year } = getAvailabilityQuarter();
    return { label: formatAvailabilityLabel(), year };
  }, []);

  const [state, setState] = useState(read);

  const refresh = useCallback(() => {
    setState(read());
  }, [read]);

  useEffect(() => {
    let timeoutId;

    const arm = () => {
      timeoutId = setTimeout(() => {
        refresh();
        arm();
      }, getMsUntilNextQuarterStart());
    };

    arm();

    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };

    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [refresh]);

  return state;
}
